import React, { useEffect, useRef, useState } from 'react';
import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ScrollableDialog from '../common/ScrollableDialog';
import PrimaryActionButton from '../common/PrimaryActionButton';
import ProductSaleLinesField from '../products/ProductSaleLinesField';

const copyLines = (lines) => (lines || []).map((line) => ({ ...line }));

const BookingAddProductsDialog = ({
  open,
  products = [],
  initialLines = [],
  currencyCode,
  onSkip,
  onConfirm,
}) => {
  const { t } = useTranslation();
  const initialLinesRef = useRef(initialLines);
  const [lines, setLines] = useState(() => copyLines(initialLines));
  initialLinesRef.current = initialLines;

  useEffect(() => {
    if (!open) {
      return;
    }
    setLines(copyLines(initialLinesRef.current));
  }, [open]);

  return (
    <ScrollableDialog
      open={open}
      onClose={onSkip}
      maxWidth="md"
      dividers
      showCloseButton
      title={t('customer.appointments.booking.addProducts')}
      titleSx={{ pb: 1, flexShrink: 0 }}
      actionsSx={{ flexShrink: 0, justifyContent: 'space-between' }}
      actions={(
        <>
          <Button onClick={onSkip} color="inherit">
            {t('customer.appointments.booking.noThanks')}
          </Button>
          <PrimaryActionButton onClick={() => onConfirm(copyLines(lines))}>
            {t('common.continue')}
          </PrimaryActionButton>
        </>
      )}
    >
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2.5 }}>
        {t('customer.appointments.booking.addProductsHint')}
      </Typography>
      <ProductSaleLinesField
        products={products}
        lines={lines}
        onChange={setLines}
        currencyCode={currencyCode}
        disableOutOfStock
      />
    </ScrollableDialog>
  );
};

export default BookingAddProductsDialog;
